module.exports = __webpack_public_path__ + "img/FahradhelmProbe.5615cd12.jpg";